// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2EFLD","alert":"SettungsInbox_alert__2VDbt"};